// §42 — age groups, colour, material come from the canonical attribute registry
import { FACETS, fieldForFacet } from "../fashionAttributes";

// constants
const INFANT_AGES = ["0-6 міс.", "6-12 міс."];

const CLOTHING_GIRLS = [
  "Верхній одяг",
  "Кофти та светри",
  "Футболки та майки",
  "Костюми та комплекти",
  "Колготки та шкарпетки",
  "Штани/Джинси/Лосіни",
  "Блузи та сорочки",
  "Спідниці",
  "Шорти",
  "Спідня білизна",
  "Сукні",
  "Інше",
];

const CLOTHING_BOYS = [
  "Верхній одяг",
  "Кофти та светри",
  "Футболки та майки",
  "Костюми та комплекти",
  "Колготки та шкарпетки",
  "Штани/Джинси",
  "Сорочки/Поло",
  "Шорти",
  "Спідня білизна",
  "Інше",
];

const CLOTHING_UNISEX = [
  "Верхній одяг",
  "Кофти та светри",
  "Футболки та майки",
  "Костюми та комплекти",
  "Колготки та шкарпетки",
  "Штани/Джинси/Лосіни",
  "Шорти",
  "Спідня білизна",
  "Інше",
];

const CLOTHING_INFANT_BASE = [
  "Набори для хрещення",
  "Костюми та комплекти",
  "Бодіки",
  "Повзунки / Штани / Шорти",
  "Кофти",
  "Верхній одяг",
  "Футболки та майки",
  "Колготки та шкарпетки",
  "Спідня білизна",
  "Інше",
];

const CLOTHING_INFANT_GIRL_EXTRA = ["Плаття", "Спідниці"];

const SHOES_SUBTYPES = [
  "Кросівки",
  "Черевики",
  "Сандалі / Босоніжки",
  "Туфлі",
  "Чоботи",
  "Капці / Домашнє",
  "Інше",
];

const TOYS_SUBTYPES = [
  "М'які",
  "Розвиваючі",
  "Конструктори",
  "Настільні ігри",
  "Пазли",
  "Ляльки / Фігурки",
  "Транспорт / Моделі",
  "Музичні",
  "Для купання",
  "Для вулиці",
  "Інше",
];

const ACCESSORIES_SUBTYPES = [
  "Шапки / Шарфи / Рукавички",
  "Головні убори",
  "Рюкзаки / Сумки",
  "Пояси",
  "Прикраси",
  "Текстиль (пелюшки / покривала)",
  "Інше",
];

const KIDS_TRANSPORT_SUBTYPES = [
  "Коляска 2в1",
  "Коляска 3в1",
  "Прогулкова / тростина",
  "Візочок для близнюків",
  "Автокрісло 0+ (до 13 кг)",
  "Автокрісло 9–18 кг",
  "Автокрісло 15–36 кг",
  "Біговел / баланс-байк",
  "Самокат дитячий",
  "Інше",
];

const CARE_SUBTYPES = [
  "Підгузки",
  "Креми / олії",
  "Присипки",
  "Гігієна (щітки / гребінці тощо)",
  "Термометри / медичні вироби",
  "Інше",
];

const CREATIVE_SUBTYPES = [
  "Альбоми / розмальовки",
  "Фарби / олівці",
  "Пластилін / ліплення",
  "Конструктори",
  "Набори для творчості",
  "Абетки / літери / цифри",
  "Дитячі муз. інструменти",
  "Інше",
];

const FEEDING_SUBTYPES = [
  "Пляшечки / соски",
  "Стерилізатори / підігрівачі",
  "Столовий посуд",
  "Слюнявчики",
  "Суміші / каші дитячі",
  "Вітаміни / добавки",
  "Інше",
];

// helpers
const getClothingSubtypeOptions = (gender, ageGroup) => {
  const isInfant = INFANT_AGES.includes(ageGroup || "");
  if (isInfant) {
    const base = [...CLOTHING_INFANT_BASE];
    if (gender === "Для дівчинки") return [...base, ...CLOTHING_INFANT_GIRL_EXTRA];
    return base;
  }
  if (gender === "Для дівчинки") return CLOTHING_GIRLS;
  if (gender === "Для хлопчика") return CLOTHING_BOYS;
  return CLOTHING_UNISEX;
};

// fields
export const kidsFields = (attrs) => {
  const a = attrs || {};
  const t = a.kidsType || "";
  const gender = a.gender || "";
  const ageGroup = a.ageGroup || "";

  // base
  const base = [
    {
      name: "gender",
      label: "Стать / Для кого",
      type: "select",
      options: ["Універсальне", "Для хлопчика", "Для дівчинки"],
      required: true,
    },
    {
      name: "ageGroup",
      label: "Вік дитини",
      type: "select",
      options: FACETS.ageGroup.values.map((x) => x.label),
      required: true,
    },
    {
      name: "kidsType",
      label: "Тип товару",
      type: "select",
      options: [
        "Одяг",
        "Взуття",
        "Іграшки",
        "Аксесуари",
        "Дитячий транспорт (коляски, автокрісла)",
        "Догляд та здоров’я (підгузки, креми, присипки)",
        "Творчість та розвиток",
        "Годування та харчування",
      ],
      required: true,
    },
    {
      name: "condition",
      label: "Стан",
      type: "select",
      options: ["Новий", "Б/в"],
      required: true,
    },
  ];

  // clothing
  const clothingSubtypeOptions = getClothingSubtypeOptions(gender, ageGroup);
  const clothing = [
    {
      name: "clothingSubtype",
      label: "Тип одягу",
      type: "select",
      options: clothingSubtypeOptions,
      showIf: (s) => s.kidsType === "Одяг",
    },
    {
      name: "clothingSeason",
      label: "Сезон",
      type: "select",
      options: ["Літо", "Осінь", "Зима", "Весна", "Цілий рік"],
      showIf: (s) => s.kidsType === "Одяг",
    },
    {
      name: "sizeClothes",
      label: "Розмір (см / UA/EU)",
      type: "text",
      placeholder: "Напр.: 92 см",
      showIf: (s) => s.kidsType === "Одяг",
    },
  ];

  // shoes
  const shoes = [
    {
      name: "shoesSubtype",
      label: "Тип взуття",
      type: "select",
      options: SHOES_SUBTYPES,
      showIf: (s) => s.kidsType === "Взуття",
    },
    {
      name: "shoesSeason",
      label: "Сезон",
      type: "select",
      options: ["Літнє", "Демісезон", "Зимове", "Універсальне"],
      showIf: (s) => s.kidsType === "Взуття",
    },
    {
      name: "shoeSize",
      label: "Розмір взуття (EU)",
      type: "text",
      placeholder: "Напр.: 28",
      showIf: (s) => s.kidsType === "Взуття",
    },
  ];

  // toys
  const toys = [
    {
      name: "toySubtype",
      label: "Тип іграшки",
      type: "select",
      options: TOYS_SUBTYPES,
      showIf: (s) => s.kidsType === "Іграшки",
    },
  ];

  // colour / material / brand for what a parent actually filters by (clothing, shoes, accessories; toys keep material)
  const WEARABLE = ["Одяг", "Взуття", "Аксесуари"];
  const kidsCommon = [
    { ...fieldForFacet("color", "clothing", {}), showIf: (s) => WEARABLE.includes(s.kidsType) },
    { ...fieldForFacet("material", "clothing", {}), showIf: (s) => [...WEARABLE, "Іграшки"].includes(s.kidsType) },
    { name: "brand", label: "Бренд (опціонально)", type: "text", placeholder: "Напр.: Zara Kids, H&M, Nike", showIf: (s) => WEARABLE.includes(s.kidsType) || s.kidsType === "Дитячий транспорт (коляски, автокрісла)" },
  ];

  // accessories
  const accessories = [
    {
      name: "accessorySubtype",
      label: "Тип аксесуару",
      type: "select",
      options: ACCESSORIES_SUBTYPES,
      showIf: (s) => s.kidsType === "Аксесуари",
    },
  ];

  // transport
  const kidsTransport = [
    {
      name: "kidsTransportSubtype",
      label: "Тип",
      type: "select",
      options: KIDS_TRANSPORT_SUBTYPES,
      showIf: (s) => s.kidsType === "Дитячий транспорт (коляски, автокрісла)",
    },
    {
      name: "carSeatIsofix",
      label: "ISOFIX",
      type: "select",
      options: ["Так", "Ні"],
      showIf: (s) =>
        s.kidsType === "Дитячий транспорт (коляски, автокрісла)" &&
        (s.kidsTransportSubtype || "").startsWith("Автокрісло"),
    },
    {
      name: "brand",
      label: "Бренд (опціонально)",
      type: "text",
      showIf: (s) => s.kidsType === "Дитячий транспорт (коляски, автокрісла)",
    },
  ];

  // care
  const care = [
    {
      name: "careSubtype",
      label: "Категорія",
      type: "select",
      options: CARE_SUBTYPES,
      showIf: (s) => s.kidsType === "Догляд та здоров’я (підгузки, креми, присипки)",
    },
    {
      name: "diaperSize",
      label: "Розмір підгузків",
      type: "select",
      options: ["NB", "1", "2", "3", "4", "5", "6", "7"],
      showIf: (s) =>
        s.kidsType === "Догляд та здоров’я (підгузки, креми, присипки)" &&
        s.careSubtype === "Підгузки",
    },
    {
      name: "packCount",
      label: "Кількість в упаковці",
      type: "number",
      showIf: (s) =>
        s.kidsType === "Догляд та здоров’я (підгузки, креми, присипки)" &&
        s.careSubtype === "Підгузки",
    },
    // При потребі додати showIf для інших підкатегорій (наприклад, креми/олії)
  ];

  // creative
  const creative = [
    {
      name: "creativeSubtype",
      label: "Категорія",
      type: "select",
      options: CREATIVE_SUBTYPES,
      showIf: (s) => s.kidsType === "Творчість та розвиток",
    },
  ];

  // feeding
  const feeding = [
    {
      name: "feedingSubtype",
      label: "Категорія",
      type: "select",
      options: FEEDING_SUBTYPES,
      showIf: (s) => s.kidsType === "Годування та харчування",
    },
    {
      name: "volume",
      label: "Обʼєм (мл) / розмір",
      type: "text",
      placeholder: "Напр.: 240 мл",
      showIf: (s) =>
        s.kidsType === "Годування та харчування" &&
        ["Пляшечки / соски", "Столовий посуд"].includes(s.feedingSubtype || ""),
    },
    {
      name: "shelfLife",
      label: "Термін придатності",
      type: "text",
      placeholder: "Напр.: до 12.2025",
      showIf: (s) =>
        s.kidsType === "Годування та харчування" &&
        ["Суміші / каші дитячі", "Вітаміни / добавки"].includes(s.feedingSubtype || ""),
    },
  ];

  return [
    ...base,
    ...clothing,
    ...shoes,
    ...toys,
    ...accessories,
    ...kidsCommon,
    ...kidsTransport,
    ...care,
    ...creative,
    ...feeding,
  ];
};
